.picker {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.row {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.main {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  min-width: 0;
}

.code {
  flex: none;
}

.details {
  overflow: hidden;
  color: var(--pencil);
  font: var(--t-small);
  text-overflow: ellipsis;
  white-space: nowrap;
}
